import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import AppModal from '@/components/AppModal/AppModal';
import classNames from './GenerateReport.module.scss';

interface ReportErrorModalProps {
  show: boolean;
  onClose: () => void;
  isStudentReport?: boolean;
}

const ReportErrorModal = ({ show, onClose, isStudentReport = false }: ReportErrorModalProps) => {
  const { t } = useAdminTranslation();

  return (
    <AppModal
      modalContentClassName={classNames.errorModal}
      show={show}
      showBackdrop={false}
      blockBodyScroll={true}
    >
      <div className={classNames.card}>
        <h1>{t('studentDataModal.report.weCouldNotProduce')}</h1>
        <div>
          <h2>{t('studentDataModal.report.weStillDontHaveAll')}</h2>
          <h3>{t('studentDataModal.report.tryAgainLater')}</h3>
        </div>
        <button onClick={onClose} aria-label={t('done').toString()}>
          {t('done')}
        </button>
      </div>
    </AppModal>
  );
};

export default ReportErrorModal;
